window.$ = window.jQuery = require('jquery');

/**
 * @class
 */
export default class Alerts {
	/**
	 * Initialize Header
	 * @function
	 */
	constructor(el) {
		this.el = el;
		if(!this.el.length) {
			return;
		}

		this.bindEvents();

	}

	fillData(currentData) {



	}

	bindEvents() {

		window.addEventListener("load", (event) => {
			setTimeout((event) => {
				this.el.slideDown(300);
			}, 400);
		});

		this.el.find('.close').on('click', (event) => {
			this.el.slideUp(300);
		});

	}

}
